import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom";
import msalInstance from './auth/msalInstance';
import { EventType } from "@azure/msal-browser";
import reportWebVitals from './reportWebVitals';
import App from "./App"
import './index.scss';

/* global Office */

msalInstance.initialize().then(() => {
  // Default to using the first account if no account is active on page load
  if (!msalInstance.getActiveAccount() && msalInstance.getAllAccounts().length > 0) {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    msalInstance.setActiveAccount(msalInstance.getAllAccounts()[0]);
  }

  // Optional - This will update account state if a user signs in from another tab or window
  msalInstance.enableAccountStorageEvents();

  msalInstance.addEventCallback((event) => {
    if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
      const account = event.payload.account;
      msalInstance.setActiveAccount(account);
    }
  });

  const root = ReactDOM.createRoot(document.getElementById("root"));
  // Function to render the app
  const renderApp = () => {
    root.render(
      <BrowserRouter>
        <App instance={msalInstance} />
      </BrowserRouter>
    );
  };

  // Initialize app based on Office.js availability
  const initApp = () => {
    if (window.officeJsAvailable && Office?.onReady) {
      Office.onReady(() => renderApp());
    } else {
      console.warn('Office.js not available - running in standalone mode');
      renderApp();
    }
  };

  window.officeJsLoadingComplete ? initApp() : window.addEventListener('officeJsReady', initApp, {once: true});
});
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
